import React from "react";
import HtmlToReactParser from "html-to-react";

import { getListGroupsFAQ, getListPostsInGroupFAQ } from "../../model/common";

import { commonErr } from "../common/errors";
import Header from "../components/header";
import Footer from "../components/footer";
import FaqBottom from "./components/faqbottom";

import { IcMinusGreen, IcPlus, IcMinusGreenCircle, IcPlusCircle } from "../common/svg.js";
import { LoadingPage } from "../common/loading";

class FaqItem extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			posts: [],
			shownDetail: {},
		};
	}

	componentDidMount() {
		const { subGroupId } = this.props;
		if (subGroupId) {
			getListPostsInGroupFAQ(subGroupId).then((resp) => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					posts: resp.data.data.posts,
				});
			});
		}
	}

	toggleDetail = (i) => {
		let { shownDetail } = this.state;
		this.setState({
			shownDetail: {
				...shownDetail,
				[i]: !shownDetail[i],
			},
		});
	};

	render() {
		const htmlToReactParser = new HtmlToReactParser.Parser();
		const { subGroupName, shown, toggleQA } = this.props;
		const { posts, shownDetail } = this.state;
		return (
			<div className={`item-title ${shown ? "active" : ""}`}>
				<div className="title" onClick={toggleQA}>
					<h5>{subGroupName}</h5>
					<div className="wrap-svg plus-icon">
						<IcPlus />
					</div>
					<div className="wrap-svg minus-icon">
						<IcMinusGreen />
					</div>
				</div>
				<div className="content-detail">
					{posts &&
						posts.map((post, idx) => (
							<div key={idx} className={`detail-title ${shownDetail[idx] ? "active" : ""}`}>
								<div onClick={() => this.toggleDetail(idx)} className="title-inner">
									<p>{post.title}</p>
									<div className="wrap-svg plus-icon">
										<IcPlusCircle />
									</div>
									<div className="wrap-svg minus-icon">
										<IcMinusGreenCircle />
									</div>
								</div>
								<div className="content">{htmlToReactParser.parse(post.content)}</div>
							</div>
						))}
				</div>
			</div>
		);
	}
}

class FaqsDetail extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			isMobile: false,
			isRenter: false,
			shown: {},
			groups: [],
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		const groupId = this.props.match.params.groupId;

		if (groupId) {
			getListGroupsFAQ(1).then((resp1) => {
				this.setState({
					err: resp1.data.error,
					errMsg: resp1.data.errorMessage,
				});
				getListGroupsFAQ(2).then((resp2) => {
					const groups = resp1.data.data.groups.concat(resp2.data.data.groups);
					for (let i = 0; i < groups.length; ++i) {
						if (groupId === groups[i].id) {
							this.setState({
								groups: groups[i],
							});
							return;
						}
					}
					this.setState({
						err: resp2.data.error,
						errMsg: resp2.data.errorMessage,
					});
				});
			});
		}

		const isMobile = this.props.location.pathname.includes("/mobile");
		const isRenter = this.props.location.pathname.includes("/renter");

		this.setState({
			isMobile,
			isRenter,
		});
	}

	toggleQA = (i) => {
		let { shown } = this.state;
		this.setState({
			shown: {
				...shown,
				[i]: !shown[i],
			},
		});
	};

	render() {
		const { err, groups, shown, isMobile, isRenter } = this.state;
		const groupName = this.props.match.params.groupName;
		var content;
		if (err !== commonErr.SUCCESS) {
			content = <LoadingPage />;
		} else {
			content = (
				<section className="body">
					<div className="faqsdetail space sec">
						<div className="faqsdetail-title">
							<div className="m-container">
								<div className="faqsdetail-title-inner">
									<img loading="lazy" className="img-title" src={groups.iconUrl} alt="" />
									<h4>{groupName}</h4>
								</div>
							</div>
						</div>
						<div className="faqsdetail-content">
							<div className="m-container">
								<div className="content-bg">
									<div className="content-title">
										{groups.subGroups &&
											groups.subGroups.map((item, idx) => (
												<FaqItem
													key={item.subGroupId}
													subGroupId={item.subGroupId}
													subGroupName={item.subGroupName}
													shown={shown[idx]}
													toggleQA={() => this.toggleQA(idx)}
												/>
											))}
									</div>
								</div>
							</div>
						</div>
					</div>
					<FaqBottom />
				</section>
			);
		}

		return (
			<div className="mioto-layout">
				{!isMobile && !isRenter && <Header />}
				{content}
				{!isMobile && !isRenter && <Footer />}
			</div>
		);
	}
}

export default FaqsDetail;
